import { useTranslation } from 'react-i18next';
import aboutImage from '../../assets/images/about.jpg';
import { motion } from 'framer-motion';
import { containerStagger, fadeUpOnView } from '../../animations/textAnimation';
import './about.css';


export default function About() {
  const { t } = useTranslation();
  
  return (
    <div className='child-page-wrapper'>
      <motion.section
        className='about-section'
        variants={containerStagger}
        initial='hidden'
        whileInView='visible'
        viewport={{ once: true, amount: 0.4 }}
      >
        <motion.div
          className='column-left'
          variants={fadeUpOnView}
        >
          <img 
            src={aboutImage} 
            alt=''
            role='presentation'
          />
        </motion.div>

        <div className='column-right'>
          <h1>
            {t('about.h1')}
          </h1>
          <motion.h2 variants={fadeUpOnView}>
            {t('about.h2-1')}
          </motion.h2>
          <motion.p variants={fadeUpOnView}>
            {t('about.h2-1-desc')}
          </motion.p>
        </div>
      </motion.section>

      <motion.section
        className='about-section'
        variants={containerStagger}
        initial='hidden'
        whileInView='visible'
        viewport={{ once: true, amount: 0.8 }}
      >
        <motion.div 
          className='column-left'
          variants={fadeUpOnView}
        >
          <h2>
            {t('about.h2-2')}
          </h2>
        </motion.div>
        <motion.div 
          className='column-right'
          variants={fadeUpOnView}
        >
          <ul className='about-list'>
            <li>
              <h3 className='about-h3'>
                {t('about.service1.title')}
              </h3>
              <p>
                {t('about.service1.desc')}
              </p>
            </li>
            <li>
              <h3 className='about-h3'>
                {t('about.service2.title')}
              </h3>
              <p>
                {t('about.service2.desc')}
              </p>
            </li>
            <li>
              <h3 className='about-h3'>
                {t('about.service3.title')}
              </h3>
              <p>
                {t('about.service3.desc')}
              </p>
            </li>
            <li>
              <h3 className='about-h3'>
                {t('about.service4.title')}
              </h3>
              <p>
                {t('about.service4.desc')}
              </p>
            </li>
          </ul>
        </motion.div>
      </motion.section>

      <motion.section 
        className='about-section'
        variants={containerStagger}
        initial='hidden'
        whileInView='visible'
        viewport={{ once: true, amount: 0.4 }}
      >
        <motion.div 
          className='column-left'
          variants={fadeUpOnView}
        >
          <h2>
            {t('about.h2-3')}
          </h2>
        </motion.div>
        <motion.div 
          className='column-right'
          variants={fadeUpOnView}
        >
          <ul className='about-list-skills'>
            <li>HTML</li>
            <li>CSS</li>
            <li>JavaScript</li>
            <li>React</li>
            <li>PHP</li>
            <li>MySQL</li>
            <li>WordPress</li>
            <li>Figma</li>
            <li>Git</li>
            <li>GitHub</li>
          </ul>
        </motion.div>
      </motion.section>
      
      <motion.section
        className='about-section'
        variants={containerStagger}
        initial='hidden'
        whileInView='visible'
        viewport={{ once: true, amount: 0.4 }}
      >
        <motion.div 
          className='column-left'
          variants={fadeUpOnView}
        >
          <h2>
            {t('about.h2-4')}
          </h2>
        </motion.div>
        <motion.div 
          className='column-right'
          variants={fadeUpOnView}
        >
          <ul className='about-list'>
            <li>
              <h3 className='about-h3'>
                {t('about.strength1.title')}
              </h3>
              <p>
                {t('about.strength1.desc')}
              </p>
            </li>
            <li>
              <h3 className='about-h3'>
                {t('about.strength2.title')}
              </h3>
              <p>
                {t('about.strength2.desc')}
              </p>
            </li>
            <li>
              <h3 className='about-h3'>
                {t('about.strength3.title')}
              </h3>
              <p>
                {t('about.strength3.desc')}
              </p>
            </li>
          </ul>
        </motion.div>
      </motion.section>
      <motion.section
        className='about-section'
        variants={containerStagger}
        initial='hidden'
        whileInView='visible'
        viewport={{ once: true, amount: 0.4 }}
      >
        <motion.div 
          className='column-left'
          variants={fadeUpOnView}
        >
          <h2>
            {t('about.h2-5')}
          </h2>
        </motion.div>
        <motion.div 
          className='column-right'
          variants={fadeUpOnView}
        >
          <ul className="about-list">
            {[1,2,3,4,5].map((num) => {
              const year = t(`about.${num}.year`);
              const title = t(`about.${num}.title`);
              const desc = t(`about.${num}.desc`);
              return (
                <li key={num} className='about-list-item-bio'>
                  {year && <span className="about-year">{year}</span>}
                  <h3 className="about-h3-bio">{title}</h3>
                  {desc && <p>{desc}</p>}
                </li>
              )
            })}
          </ul>

        </motion.div>
      </motion.section>
    </div>
  );
}
